import React, { useEffect, useState } from "react";
import AdminSidebar from "./AdminSidebar";
import AdminHeader from "./AdminHeader";
import toast from "react-hot-toast";
import axios from "axios";
import { base_url } from "./AgentWhitelist";

function DeleteCustomers() {
  const [list, setList] = useState([]);

  // SAME SIDEBAR LOGIC AS CURRENCY
  const [isSidebarOpen, setIsSidebarOpen] = useState(!(window.innerWidth < 768));
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      if (!mobile) setIsSidebarOpen(true);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const auth = localStorage.getItem("admin");

  const getDeleted = async () => {
    try {
      const res = await axios.get(`${base_url}/api/get-deleted-customers`, {
        headers: { Authorization: auth },
      });
      setList(res.data);
    } catch (err) {
      toast.error("Failed to load customers!");
    }
  };

  useEffect(() => {
    getDeleted();
  }, []);

  const deleteCustomer = async (id) => {
  if (!window.confirm("Are you sure you want to delete permanently?")) return;

  try {
    await axios.delete(`${base_url}/api/delete-customer/${id}`, {
      headers: { Authorization: auth }
    });

    toast.success("Customer deleted permanently!");
    getDeleted();

  } catch (err) {
    toast.error("Delete failed!");
  }
};


  const restoreCustomer = async (id) => {
    try {
      await axios.post(
        `${base_url}/api/restore-customer/${id}`,
        {},
        { headers: { Authorization: auth } }
      );
      toast.success("Customer restored successfully!");
      getDeleted();
    } catch (err) {
      toast.error("Restore failed!");
    }
  };

  return (
    <div className="wrapper bg-light">
      
      {/* 🟦 SAME POSITION AS CURRENCY PAGE */}
      <AdminSidebar
        isSidebarOpen={isSidebarOpen}
        toggleSidebar={toggleSidebar}
        isMobile={isMobile}
      />

      {/* 🟦 HEADER SHOULD BE EXACTLY HERE */}
      <AdminHeader
        toggleSidebar={toggleSidebar}
        isSidebarOpen={isSidebarOpen}
        isMobile={isMobile}
      />

      {/* 🟦 SAME CONTENT WRAPPER LIKE CURRENCY */}
      <div
        className={`content-wrapper p-1 ${
          !isMobile && isSidebarOpen ? "" : "open-content-wrapper"
        }`}
        style={{ marginLeft: !isMobile && isSidebarOpen ? "" : "0" }}
      >
        <div className="main-content">
          <div className="container-fluid py-4">

            <h3 className="text-dark mb-4">Deleted Customers</h3>

            <div className="table-responsive bg-white shadow-sm rounded">
              <table className="table table-striped table-hover bg-gray">
                <thead className="table-light bg-gray text-nowrap">
                  <tr className="text-center border">
                    <td className="border p-3 fw-bold">Customer ID</td>
                    <td className="border p-3 fw-bold">Customer Name</td>
                    <td className="border p-3 fw-bold">Username</td>
                    <td className="border p-3 fw-bold">Password</td>
                    <td className="border p-3 fw-bold">Phone</td>
                    <td className="border p-3 fw-bold">Wallet</td>
                    <td className="border p-3 fw-bold">Status</td>
                    <td className="border p-3 fw-bold">Currency</td>
                    <td className="border p-3 fw-bold">Verify Key</td>
                    <td className="border p-3 fw-bold">Secret Key</td>
                    <td className="border p-3 fw-bold">API Type</td>
                    <td className="border p-3 fw-bold">Project IP</td>
                    <td className="border p-3 fw-bold">Domain Name</td>
                    <td className="border p-3 fw-bold">Project Name</td>
                    <td className="border p-3 fw-bold">Project URL</td>
                    <td className="border p-3 fw-bold">ggr</td>
                    <td className="border p-3 fw-bold">Created By</td>
                    <td className="border p-3 fw-bold">Date</td>
                    <td className="border p-3 fw-bold">Action</td>
                  </tr>
                </thead>

                <tbody>
                  {list.length === 0 ? (
                    <tr>
                      <td colSpan="19" className="text-center text-muted py-3">
                        No Deleted Customers Found
                      </td>
                    </tr>
                  ) : (
                    list.map((row) => (
                      <tr className="text-center" key={row.id}>
                        <td>{row.customerid}</td>
                        <td>{row.customername}</td>
                        <td>{row.username}</td>
                        <td>{row.password}</td>
                        <td>{row.phone}</td>
                        <td>{row.wallet}</td>
                        <td>{row.status}</td>
                        <td>{row.currency}</td>
                        <td>{row.public_key}</td>
                        <td>{row.private_key}</td>
                        <td>{row.api_type}</td>
                        <td>{row.ip}</td>
                        <td>{row.domain}</td>
                        <td>{row.project_name}</td>
                        <td>{row.project_url}</td>
                        <td>{row.ggr}</td>
                        <td>{row.created_by}</td>
                        <td>{new Date(row.date).toLocaleDateString("en-GB")}</td>

                        <td>
  <button
    className="btn btn-success btn-sm me-2"
    onClick={() => restoreCustomer(row.id)}
  >
    Restore
  </button>

  <button
    className="btn btn-danger btn-sm"
    onClick={() => deleteCustomer(row.id)}
  >
    Delete
  </button>
</td>

                      </tr>
                    ))
                  )}
                </tbody>

              </table>
            </div>

          </div>
        </div>
      </div>

    </div>
  );
}

export default DeleteCustomers;
